<template>
  <el-card v-loading="loading">
    <div ref="scrollContainer" id="page-panel" >
      <!-- <resize-observer @notify="__resizeHanlder" /> -->

        <div class="customer-top-nav">
          <div class="title">
            <span>{{$t('reports.names.'+reportCode)}}</span><br>
          </div>
          <div class="controls no-print">
             <el-button
              v-if="isFiltered"
              type="primary"
              size="small"
              @click="handleResetFilters">
             Retirer les filtres <i class="mdi mdi-filter-remove"/>
            </el-button>
    				 <el-button type="primary" @click="openFilterDialog" size="small"><i class="mdi mdi-filter"></i> </el-button>
    			</div>
        </div>

        <p>
          <span class="fs-14 secondary-text">{{companyName}}</span><br>
          <span class="fs-14 secondary-text">{{currentFilterPeriod}}</span><br>
          <span class="fs-14 secondary-text" v-if="customerName!=null && customerName!='' && filters.customerId!=null">Client sélectionné : {{customerName}}</span>
          <span class="fs-14 secondary-text" v-else>Tous les clients</span><br>
          <span class="fs-14 secondary-text" v-if="productName!=null && filters.product!=null">Produit sélectionné : {{productName}}</span>
          <span class="fs-14 secondary-text" v-else>Tous les produits</span><br>
          <span class="fs-14 secondary-text" v-if="providerName!=null && filters.provider!=null">Fournisseur sélectionné : {{providerName}}</span>
          <span class="fs-14 secondary-text" v-else>Tous les fournisseurs</span>
        </p>
        <div id="printMe">
        <el-table :data="summary" :style="tableWidth" ref="summary">
          <el-table-column  align="left" label="Sommaire">
            <template slot-scope="scope">
              <span class="fs-14" v-if="scope.row.header"><strong>{{$t('reports.INTENTS.headers.'+scope.row.name)}}</strong></span>
            </template>
          </el-table-column>
          <el-table-column  align="right" >
            <template slot-scope="scope">
              <span class="fs-14"><strong>{{scope.row.total}}</strong></span>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <h4 class="text-center">Top 10 des fournisseurs selon la quantité</h4>
              <div id="chartTop5" :style="{height:'380px',width:'100%', 'text-align':'center', marginTop:'20px'}"></div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <h4 class="text-center">Top 10 des produits selon la quantité</h4>
              <div id="chartTop5Quantities" :style="{height:'380px',width:'100%', 'text-align':'center', marginTop:'20px'}"></div>
          </el-col>
        </el-row>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;margin-top:40px">
          <h3 style="margin: 0;">Quantités totales par produit</h3>
          <el-dropdown size="small" type="default">
            <el-button type="primary" size="small">
              <i class="el-icon-download"></i> Télécharger
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="downloadProductsTable('csv')"><i class="el-icon-document" style="color: #21ba45;"></i> CSV</el-dropdown-item>
              <el-dropdown-item @click.native="downloadProductsTable('excel')"><i class="mdi mdi-file-excel" style="color: #217346;"></i> Excel</el-dropdown-item>
              <el-dropdown-item @click.native="downloadProductsTable('html')"><i class="el-icon-document-copy" style="color: #e34c26;"></i> HTML</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-divider/>
        <el-table :data="productsWithIntentsInPage" :style="tableWidth" stripe empty-text="Aucun produit avec intention d'achat" @sort-change="handleProductsSort">
          <el-table-column
            prop="name"
            sortable="custom"
            show-overflow-tooltip
            label="Produit"
            min-width="250">
            <template slot-scope="scope">
              <div>
                <div>{{scope.row.name}}</div>
                <div class="fs-12 secondary-text">
                  {{scope.row.providerName}} | UVC: {{scope.row.uvc != null ? scope.row.uvc : '-'}} | {{scope.row.lblFormat != null ? scope.row.lblFormat : '-'}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="providerName"
            sortable="custom"
            show-overflow-tooltip
            label="Fournisseur"
            min-width="200">
          </el-table-column>
          <el-table-column
            prop="totalQuantity"
            sortable="custom"
            label="Quantité totale"
            align="right"
            width="150">
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="productsPagination.page"
          :page-size="productsPagination.size"
          layout="total, ->, prev, pager, next"
          :total="productsTotalRecords"
          :hide-on-single-page="true"
        ></el-pagination>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;margin-top:40px">
          <h3 style="margin: 0;">Producteurs selon le nombre de produits en intention d'achat</h3>
          <el-dropdown size="small" type="default">
            <el-button type="primary" size="small">
              <i class="el-icon-download"></i> Télécharger
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="downloadProducersTable('csv')"><i class="el-icon-document" style="color: #21ba45;"></i> CSV</el-dropdown-item>
              <el-dropdown-item @click.native="downloadProducersTable('excel')"><i class="el-icon-tickets" style="color: #217346;"></i> Excel</el-dropdown-item>
              <el-dropdown-item @click.native="downloadProducersTable('html')"><i class="el-icon-document-copy" style="color: #e34c26;"></i> HTML</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-divider/>
        <el-table :data="producersWithIntentsInPage" :style="tableWidth" stripe empty-text="Aucun producteur avec intention d'achat" @sort-change="handleProducersSort">
          <el-table-column
            prop="providerName"
            sortable="custom"
            show-overflow-tooltip
            label="Producteur"
            min-width="300">
          </el-table-column>
          <el-table-column
            prop="totalProducts"
            sortable="custom"
            label="Nombre total de produits"
            align="right"
            width="220">
          </el-table-column>
          <el-table-column
            prop="totalQuantity"
            sortable="custom"
            label="Quantité totale de bouteilles"
            align="right"
            width="240">
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="producersPagination.page"
          :page-size="producersPagination.size"
          layout="total, ->, prev, pager, next"
          :total="producersTotalRecords"
          :hide-on-single-page="true"
        ></el-pagination>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;margin-top:40px">
          <h3 style="margin: 0;">Intentions d'achats</h3>
          <el-dropdown size="small" type="default">
            <el-button type="primary" size="small">
              <i class="el-icon-download"></i> Télécharger
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="downloadIntentsTable('csv')"><i class="el-icon-document" style="color: #21ba45;"></i> CSV</el-dropdown-item>
              <el-dropdown-item @click.native="downloadIntentsTable('excel')"><i class="el-icon-tickets" style="color: #217346;"></i> Excel</el-dropdown-item>
              <el-dropdown-item @click.native="downloadIntentsTable('html')"><i class="el-icon-document-copy" style="color: #e34c26;"></i> HTML</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-divider/>
        <el-pagination
          :small="pagination.small"
          :current-page.sync="pagination.page"
          :page-sizes="pagination.sizes"
          :page-size.sync="pagination.size"
          :layout="pagination.layout"
          :total="totalRecords"
          :hide-on-single-page="true"
        ></el-pagination>
        <el-table :data="listInPage" :style="tableWidth" stripe empty-text="Il n'y a aucun paiement pour cette période">
          <el-table-column
            prop="date"
            label="Date"
            show-overflow-tooltip
            width="120">
            <template slot-scope="scope">
              <span>{{_moment(scope.row.created_at,'DD-MM-YYYY')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            label="# réserv."
            width="120">
            <template slot-scope="scope">
              <PortausLink :id="scope.row.id" path="/reservations/" :label="scope.row.id.toString()"></PortausLink>
            </template>
          </el-table-column>
          <el-table-column
            prop="customer.name"
            show-overflow-tooltip
            label="Client">
            <template slot-scope="scope">
              <PortausLink :id="scope.row.customer.id" path="/customers/" :label="getCustomerName(scope.row.customer)"></PortausLink>
            </template>
          </el-table-column>
          <el-table-column
            prop="product.name"
            show-overflow-tooltip
            label="Produit">
            <template slot-scope="scope">
              <span>{{scope.row.product.name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="Format">
            <template slot-scope="scope">
              <UnitFormatVolumeLabel
                class="ml-5 mb-3"
                :unit="scope.row.product.unit"
                :uvc="scope.row.product.uvc"
                :format="scope.row.product.format"
                :volume="scope.row.product.volume" />
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="Fournisseur">
            <template slot-scope="scope">
              <PortausLink v-if="scope.row.product.provider != null" :id="scope.row.product.provider.id" path="/customers/" :label="scope.row.product.provider.name"></PortausLink>
            </template>
          </el-table-column>
          <el-table-column
            prop="availableQty"
            show-overflow-tooltip
            label="Quantité"
            align="center"
            width="100">
            <template slot-scope="scope">
              {{scope.row.availableQty}}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :small="pagination.small"
          :current-page.sync="pagination.page"
          :page-sizes="pagination.sizes"
          :page-size.sync="pagination.size"
          :layout="pagination.layout"
          :total="totalRecords"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
      <reportFilter :visible="reportFilterVisible"
                    @close="closeFilterDialog"
                    :predefinedPeriod="predefinedPeriod"
                    :period="period"
                    :startDate="this.filters.startDate"
                    :endDate="this.filters.endDate"
                    :productFilter="true"
                    :selectedProduct="this.filters.product"
                    :customerFilter="true"
                    :customer="selectedCustomer"
                    :providerFilter="true"
                    :provider="selectedProvider"
                    @applyFilter="handleFilter">
      </reportFilter>
    </div>
  </el-card>
</template>
<script>
//import Section
import reservationAPI from '@/services/API/reservation.js'
import moment from 'moment'
import reportFilter from './report-filter'
import reportUtil from '@/utils/report-util.js'
import PortausLink from '@/components/portaus-link'
import CustomerUtil from '@/utils/customer-util'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel';
import * as echarts from 'echarts';

export default {
  name : "report-intents",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    month : Object,
    lastMonth : Object,
    companyName : '',
  },
  data() {
    return {
      chart: null,
      chartQty: null,
      output : null,
      data : [],
      loading:true,
      filters : {
        range : null,
        startDate : null,
        endDate : null,
        product : null,
        customerId : null,
        providerId: null,
        customer: null,
        provider: null,
      },
      reportFilterVisible : false,
      pageWidth : null,
      pageHeight : null,
      pagination: {
        page: 1,
        size: 20,
        sizes: [10, 15, 20, 30, 50, 100],
        layout: 'total, ->, prev, pager, next, sizes',
        small: false
      },
      productsSortProp: 'totalQuantity',
      productsSortOrder: 'descending',
      producersSortProp: 'totalProducts',
      producersSortOrder: 'descending',
      productsPagination: {
        page: 1,
        size: 10,
      },
      producersPagination: {
        page: 1,
        size: 10,
      },
    };
  },
  components : {
    reportFilter,
    PortausLink,
    UnitFormatVolumeLabel,
  },
  computed : {
    isFiltered () {
      return this.filters.product != null || this.filters.customerId != null || this.filters.providerId != null;
    },
    groupedProduct () {
      return _.groupBy(this.data, 'product.id');
    },
    groupedByProvider () {
      return _.groupBy(this.data, 'product.provider.id');
    },
    top5ChartData () {
      const groupedByProviderOrdered = _.sortBy(this.groupedByProvider, g => _.size(g));
      // on les a ordonné. On va chercher les 10 plus grands qui se retrouvent a la fin
      const top5 = _.slice(groupedByProviderOrdered, _.size(groupedByProviderOrdered) - 10);
      const top5Data = [];
      _.forEach(top5, (t) => {
        let sum = 0;
        _.forEach(t, (intent) => {
          sum += intent.availableQty;
        })
        const name = _.get(_.head(t), 'product.provider.name');
        const id = _.get(_.head(t), 'product.provider.id');
        top5Data.push({
          id,
          name,
          value: sum,
          type: 'PROVIDER',
        })
      })
      return top5Data;
    },
    top5QuantitiesChartData () {
      let nbUnitaray = 0;
      const groupedByProduct = {};
      const sumMatriceByProduct = {};
      _.forEach(this.data, (d) => {
        if (groupedByProduct[d.product.id] == null) {
          groupedByProduct[d.product.id] = [];
          sumMatriceByProduct[d.product.id] = {
            id: d.product.id,
            sum: 0,
          }
        }
        groupedByProduct[d.product.id].push(d);
        sumMatriceByProduct[d.product.id].sum += d.availableQty;
      })

      const sumMatriceByProductOrdered = _.sortBy(sumMatriceByProduct, 'sum');
      const top5 = _.slice(sumMatriceByProductOrdered, _.size(sumMatriceByProductOrdered) - 10);
      const top5Data = [];
      _.forEach(top5, (t) => {
        top5Data.push({
          id: _.get(_.head(groupedByProduct[t.id]), 'product.id'),
          name: _.get(_.head(groupedByProduct[t.id]), 'product.name'),
          value: t.sum,
          type: 'PRODUCT'
        })
      })
      return top5Data;
    },
    productName () {
      return _.get(this.filters, 'product.name');
    },
    providerName () {
      return _.get(this.filters, 'provider.name');
    },
    selectedCustomer(){
      if(this.filters.customerId!=null && this.filters.customerId!=undefined){
        return {id:this.filters.customerId}
      }else{
        return null;
      }
    },
    selectedProvider(){
      if(this.filters.providerId!=null && this.filters.providerId!=undefined){
        return {id:this.filters.providerId}
      }else{
        return null;
      }
    },
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },
    currentFilterPeriod(){
      return reportUtil.currentFilterPeriod(this.fiscalYearDate,this.lastFiscalYearDate,this.filters.range,this.filters.startDate,this.filters.endDate )
    },
    predefinedPeriod(){
      if(this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        return [
          {code : 'UNTIL_TODAY', description: moment().format('DD MMM YYYY')},
          {code : 'MONTH', description:this.month.startDate.format('DD MMM YYYY') + '-'+this.month.endDate.format('DD MMM YYYY')},
          {code : 'LAST_MONTH', description:this.lastMonth.startDate.format('DD MMM YYYY') + '-'+this.lastMonth.endDate.format('DD MMM YYYY')},
          {code : 'FISCAL_YEAR',description:this.fiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.fiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'LAST_FISCAL_YEAR',description:this.lastFiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.lastFiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'CUSTOM', range:true}
        ]
      }else{
        return [];
      }

    },
    period(){
      return _.find(this.predefinedPeriod, p=>{return p.code==this.filters.range})
    },
    reportCode(){
      return this.$route.params.code;
    },
    summary(){
      let data = [
        {name:'nbIntents', header:true, total:_.size(this.data)}
      ]
      const groupedByProduct = {};
      let nbUnitaray = 0;
      let nbUVC = 0;
      _.forEach(this.data, (d) => {
        if (groupedByProduct[d.product.id] == null) groupedByProduct[d.product.id] = [];
        groupedByProduct[d.product.id].push(d);
        nbUnitaray += d.availableQty;
        nbUVC += Math.round((d.availableQty / d.product.uvc) * 100) / 100;
      })
      // const groupeByProduct = _.groupBy(this.data, 'product.id');
      data.push(  {name:'nbProducts', header:true, total:_.size(groupedByProduct)});
      data.push(  {name:'nbUnitaryProduct', header:true, total: nbUnitaray});
      data.push(  {name:'nbUvcProduct', header:true, total: nbUVC});
      return data;
    },
    usableData(){
      return this.data;
    },
    totalRecords() {
			return this.usableData.length
		},
    listInPage(){
      let from = (this.currentPage - 1) * this.itemPerPage
      let to = from + (this.itemPerPage*1)
      //return this.listSortered.slice(from, to)
      return this.usableData.slice(from, to)
    },
    currentPage: {
			get() {
				return this.pagination.page
			},
			set(val) {
				this.pagination.page = val
			}
		},
		itemPerPage() {
			return this.pagination.size
		},
		productsWithIntents() {
			const productsMap = {};
			
			// Aggregate quantities by product
			_.forEach(this.data, (intent) => {
				const productId = intent.product.id;
				if (productsMap[productId] == null) {
					productsMap[productId] = {
						id: intent.product.id,
						name: intent.product.name,
						providerName: _.get(intent, 'product.provider.name', 'N/A'),
            uvc: _.get(intent, 'product.uvc', null),
            lblFormat: _.get(intent, 'product.lblFormat', null),
						totalQuantity: 0
					};
				}
				productsMap[productId].totalQuantity += intent.availableQty;
			});
			
			// Convert to array and sort based on current sort settings
			const result = _.values(productsMap);
			const sortOrder = this.productsSortOrder === 'ascending' ? 'asc' : 'desc';
			return _.orderBy(result, [this.productsSortProp], [sortOrder]);
		},
    productsTotalRecords() {
      return this.productsWithIntents.length;
    },
    productsWithIntentsInPage() {
      const from = (this.productsPagination.page - 1) * this.productsPagination.size;
      const to = from + this.productsPagination.size;
      return this.productsWithIntents.slice(from, to);
    },
    producersWithIntents() {
      const providersMap = {};

      _.forEach(this.data, (intent) => {
        const providerId = _.get(intent, 'product.provider.id');
        const providerName = _.get(intent, 'product.provider.name');
        const productId = _.get(intent, 'product.id');

        if (providerId == null || providerName == null) {
          return;
        }

        if (providersMap[providerId] == null) {
          providersMap[providerId] = {
            id: providerId,
            providerName,
            productIds: {},
            totalProducts: 0,
            totalQuantity: 0,
          };
        }

        if (productId != null && providersMap[providerId].productIds[productId] !== true) {
          providersMap[providerId].productIds[productId] = true;
          providersMap[providerId].totalProducts += 1;
        }

        providersMap[providerId].totalQuantity += _.get(intent, 'availableQty', 0);
      });

      const result = _.map(providersMap, (provider) => ({
        id: provider.id,
        providerName: provider.providerName,
        totalProducts: provider.totalProducts,
        totalQuantity: provider.totalQuantity,
      }));

      const sortOrder = this.producersSortOrder === 'ascending' ? 'asc' : 'desc';
      return _.orderBy(result, [this.producersSortProp], [sortOrder]);
    },
    producersTotalRecords() {
      return this.producersWithIntents.length;
    },
    producersWithIntentsInPage() {
      const from = (this.producersPagination.page - 1) * this.producersPagination.size;
      const to = from + this.producersPagination.size;
      return this.producersWithIntents.slice(from, to);
    },
  },
  methods : {
    handleProductsSort({column, prop, order}) {
      // prop will be 'name' or 'totalQuantity'
      // order will be 'ascending', 'descending', or null (if clicking again to reset)
      if (order === null) {
        // Reset to default sort
        this.productsSortProp = 'totalQuantity';
        this.productsSortOrder = 'descending';
      } else {
        this.productsSortProp = prop;
        this.productsSortOrder = order;
      }
      this.productsPagination.page = 1;
    },
    handleProducersSort({prop, order}) {
      if (order === null) {
        this.producersSortProp = 'totalProducts';
        this.producersSortOrder = 'descending';
      } else {
        this.producersSortProp = prop;
        this.producersSortOrder = order;
      }
      this.producersPagination.page = 1;
    },
    handleResetFilters () {
      this.product = null;
      this.customer = null;
      this.provider = null;
      localStorage.intents_customerId = undefined;
      localStorage.intents_customerName = undefined;
      localStorage.intents_providerId = undefined;
      localStorage.intents_providerName = undefined;
      localStorage.intents_product = null;
      this.setFilters();
      this.fetchData();

    },
    handleProductClick (params) {
      if (params.data.type === 'PRODUCT') {
        this.filters.product = _.head(this.groupedProduct[params.data.id]).product;
        localStorage.intents_product = _.get(this.filters, 'product') != null ? JSON.stringify(_.get(this.filters, 'product')) : null;
      } else if (params.data.type === 'PROVIDER') {
        this.filters.provider = _.get(_.head(this.groupedByProvider[params.data.id]), 'product.provider');
        localStorage.intents_provider = _.get(this.filters, 'provider') != null ? JSON.stringify(_.get(this.filters, 'provider')) : null;
        localStorage.intents_providerId = _.get(this.filters, 'provider.id');
      }
      this.setFilters();
      this.fetchData();
    },
    initChart () {
      this.chartQty = echarts.init(document.getElementById('chartTop5Quantities'))
      this.chartQty.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}',
        },
        legend: {
          bottom: '0%',
          left: 'center'
        },
        series: [
          {
            name: 'Top 10',
            type: 'pie',
            radius: ['24%', '46%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
              }
            },
            labelLine: {
              show: false
            },
            data: this.top5QuantitiesChartData,
          }
        ]
      });
      const _this = this;
      this.chartQty.on('click', 'series', this.handleProductClick);
      this.chart = echarts.init(document.getElementById('chartTop5'))
      this.chart.setOption({
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '0%',
          left: 'center'
        },
        series: [
          {
            name: 'Top 10',
            type: 'pie',
            radius: ['24%', '46%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
              }
            },
            labelLine: {
              show: false
            },
            data: this.top5ChartData,
          }
        ]
      });
      this.chart.on('click', 'series', this.handleProductClick);
    },
    getPreparedFilters () {
      let filters = _.cloneDeep(this.filters);
      if(moment(filters.startDate).isValid()){
        filters.startDate = moment(filters.startDate).format('YYYY-MM-DD Z');
      } else {
        delete filters.startDate;
      }

      if(filters.endDate!=null){
        filters.endDate = moment(filters.endDate).add(1, 'days').format('YYYY-MM-DD Z');
      }

      if (filters.product != null) {
        filters.productId = _.get(filters, 'product.id');
        delete filters.product;
      }

      delete filters.customer;
      delete filters.provider;

      filters.intent = true;
      return filters;
    },
    getCustomerName(customer){
      return CustomerUtil.customerName(customer.name, customer.usual_name);
    },
    downloadReport(){
      const filters = this.getPreparedFilters();
      filters.type='ADMIN_INTENTS';

      let filename = 'INTENTS_REPORT_'+moment(this.filters.startDate).format('YYYY-MM-DD')+'-'+moment(this.filters.endDate).format('YYYY-MM-DD');
      filename+=".csv";

      return reservationAPI.downloadReservationReport(filters, filename);
    },
    downloadProductsTable(format) {
      const filename = 'PRODUITS_QUANTITES_'+moment(this.filters.startDate).format('YYYY-MM-DD')+'-'+moment(this.filters.endDate).format('YYYY-MM-DD');
      
      if (format === 'csv') {
        this.downloadProductsTableCSV(filename);
      } else if (format === 'excel') {
        this.downloadProductsTableExcel(filename);
      } else if (format === 'html') {
        this.downloadProductsTableHTML(filename);
      }
    },
    downloadProductsTableCSV(filename) {
      const headers = ['Produit', 'Fournisseur', 'Quantité totale'];
      const rows = this.productsWithIntents.map(product => [
        product.name,
        product.providerName,
        product.totalQuantity
      ]);
      
      let csv = headers.join(',') + '\n';
      rows.forEach(row => {
        csv += row.map(cell => {
          // Escape quotes and wrap in quotes if contains comma
          const escaped = String(cell).replace(/"/g, '""');
          return escaped.includes(',') ? `"${escaped}"` : escaped;
        }).join(',') + '\n';
      });
      
      this.downloadFile(csv, filename + '.csv', 'text/csv');
    },
    downloadProductsTableExcel(filename) {
      const headers = ['Produit', 'Fournisseur', 'Quantité totale'];
      const rows = this.productsWithIntents.map(product => [
        product.name,
        product.providerName,
        product.totalQuantity
      ]);
      
      // Create HTML table for Excel
      let html = '<table border="1"><thead><tr>';
      headers.forEach(header => {
        html += `<th style="background-color: #4472C4; color: white; font-weight: bold;">${header}</th>`;
      });
      html += '</tr></thead><tbody>';
      
      rows.forEach(row => {
        html += '<tr>';
        row.forEach((cell, index) => {
          const style = index === 2 ? 'text-align: right;' : '';
          html += `<td style="${style}">${cell}</td>`;
        });
        html += '</tr>';
      });
      html += '</tbody></table>';
      
      this.downloadFile(html, filename + '.xls', 'application/vnd.ms-excel');
    },
    downloadProductsTableHTML(filename) {
      const headers = ['Produit', 'Fournisseur', 'Quantité totale'];
      const rows = this.productsWithIntents.map(product => [
        product.name,
        product.providerName,
        product.totalQuantity
      ]);
      
      let html = `<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <title>${filename}</title>
  <style>
    body { font-family: Arial, sans-serif; margin: 20px; }
    h1 { color: #333; }
    table { border-collapse: collapse; width: 100%; margin-top: 20px; }
    thead { background-color: #4472C4; color: white; }
    th, td { border: 1px solid #ddd; padding: 12px; text-align: left; }
    tr:nth-child(even) { background-color: #f9f9f9; }
    tr:hover { background-color: #f0f0f0; }
    td:last-child { text-align: right; }
  </style>
</head>
<body>
  <h1>Quantités totales par produit</h1>
  <p>Période: ${moment(this.filters.startDate).format('DD/MM/YYYY')} - ${moment(this.filters.endDate).format('DD/MM/YYYY')}</p>
  <table>
    <thead>
      <tr>`;
      
      headers.forEach(header => {
        html += `<th>${header}</th>`;
      });
      html += '</tr></thead><tbody>';
      
      rows.forEach(row => {
        html += '<tr>';
        row.forEach((cell, index) => {
          const style = index === 2 ? ' style="text-align: right;"' : '';
          html += `<td${style}>${cell}</td>`;
        });
        html += '</tr>';
      });
      
      html += `</tbody>
  </table>
</body>
</html>`;
      
      this.downloadFile(html, filename + '.html', 'text/html');
    },
    downloadProducersTable(format) {
      const filename = 'PRODUCTEURS_INTENTIONS_'+moment(this.filters.startDate).format('YYYY-MM-DD')+'-'+moment(this.filters.endDate).format('YYYY-MM-DD');

      if (format === 'csv') {
        this.downloadProducersTableCSV(filename);
      } else if (format === 'excel') {
        this.downloadProducersTableExcel(filename);
      } else if (format === 'html') {
        this.downloadProducersTableHTML(filename);
      }
    },
    downloadProducersTableCSV(filename) {
      const headers = ['Producteur', 'Nombre total de produits', 'Quantité totale de bouteilles'];
      const rows = this.producersWithIntents.map((provider) => [
        provider.providerName,
        provider.totalProducts,
        provider.totalQuantity,
      ]);

      let csv = headers.join(',') + '\n';
      rows.forEach((row) => {
        csv += row.map((cell) => {
          const escaped = String(cell).replace(/"/g, '""');
          return escaped.includes(',') ? `"${escaped}"` : escaped;
        }).join(',') + '\n';
      });

      this.downloadFile(csv, filename + '.csv', 'text/csv');
    },
    downloadProducersTableExcel(filename) {
      const headers = ['Producteur', 'Nombre total de produits', 'Quantité totale de bouteilles'];
      const rows = this.producersWithIntents.map((provider) => [
        provider.providerName,
        provider.totalProducts,
        provider.totalQuantity,
      ]);

      let html = '<table border="1"><thead><tr>';
      headers.forEach((header) => {
        html += `<th style="background-color: #4472C4; color: white; font-weight: bold;">${header}</th>`;
      });
      html += '</tr></thead><tbody>';

      rows.forEach((row) => {
        html += '<tr>';
        row.forEach((cell, index) => {
          const style = index >= 1 ? 'text-align: right;' : '';
          html += `<td style="${style}">${cell}</td>`;
        });
        html += '</tr>';
      });
      html += '</tbody></table>';

      this.downloadFile(html, filename + '.xls', 'application/vnd.ms-excel');
    },
    downloadProducersTableHTML(filename) {
      const headers = ['Producteur', 'Nombre total de produits', 'Quantité totale de bouteilles'];
      const rows = this.producersWithIntents.map((provider) => [
        provider.providerName,
        provider.totalProducts,
        provider.totalQuantity,
      ]);

      let html = `<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <title>${filename}</title>
  <style>
    body { font-family: Arial, sans-serif; margin: 20px; }
    h1 { color: #333; }
    table { border-collapse: collapse; width: 100%; margin-top: 20px; }
    thead { background-color: #4472C4; color: white; }
    th, td { border: 1px solid #ddd; padding: 12px; text-align: left; }
    tr:nth-child(even) { background-color: #f9f9f9; }
    tr:hover { background-color: #f0f0f0; }
    td:last-child { text-align: right; }
  </style>
</head>
<body>
  <h1>Producteurs selon le nombre de produits en intention d'achat</h1>
  <p>Période: ${moment(this.filters.startDate).format('DD/MM/YYYY')} - ${moment(this.filters.endDate).format('DD/MM/YYYY')}</p>
  <table>
    <thead>
      <tr>`;

      headers.forEach((header) => {
        html += `<th>${header}</th>`;
      });
      html += '</tr></thead><tbody>';

      rows.forEach((row) => {
        html += '<tr>';
        row.forEach((cell, index) => {
          const style = index >= 1 ? ' style="text-align: right;"' : '';
          html += `<td${style}>${cell}</td>`;
        });
        html += '</tr>';
      });

      html += `</tbody>
  </table>
</body>
</html>`;

      this.downloadFile(html, filename + '.html', 'text/html');
    },
    downloadIntentsTable(format) {
      const filename = 'INTENTIONS_ACHAT_'+moment(this.filters.startDate).format('YYYY-MM-DD')+'-'+moment(this.filters.endDate).format('YYYY-MM-DD');

      if (format === 'csv') {
        this.downloadIntentsTableCSV(filename);
      } else if (format === 'excel') {
        this.downloadIntentsTableExcel(filename);
      } else if (format === 'html') {
        this.downloadIntentsTableHTML(filename);
      }
    },
    getIntentFormatLabel(intent) {
      const uvc = _.get(intent, 'product.uvc');
      const volume = _.get(intent, 'product.volume');
      const format = _.get(intent, 'product.format');

      const leftPart = uvc != null ? `${uvc} x ` : '';
      const volumePart = volume != null ? `${volume}` : '';
      const formatPart = format != null ? `${format}` : '';

      return `${leftPart}${volumePart}${formatPart}`.trim();
    },
    getIntentsExportRows() {
      return this.usableData.map((intent) => ({
        date: this._moment(intent.created_at, 'DD-MM-YYYY'),
        reservationId: _.get(intent, 'id'),
        customerName: this.getCustomerName(_.get(intent, 'customer', {})),
        productName: _.get(intent, 'product.name', ''),
        formatLabel: this.getIntentFormatLabel(intent),
        providerName: _.get(intent, 'product.provider.name', ''),
        quantity: _.get(intent, 'availableQty', 0),
      }));
    },
    downloadIntentsTableCSV(filename) {
      const headers = ['Date', '# reserv.', 'Client', 'Produit', 'Format', 'Fournisseur', 'Quantite'];
      const rows = this.getIntentsExportRows().map((row) => [
        row.date,
        row.reservationId,
        row.customerName,
        row.productName,
        row.formatLabel,
        row.providerName,
        row.quantity,
      ]);

      let csv = headers.join(',') + '\n';
      rows.forEach((row) => {
        csv += row.map((cell) => {
          const escaped = String(cell == null ? '' : cell).replace(/"/g, '""');
          return escaped.includes(',') ? `"${escaped}"` : escaped;
        }).join(',') + '\n';
      });

      this.downloadFile(csv, filename + '.csv', 'text/csv');
    },
    downloadIntentsTableExcel(filename) {
      const headers = ['Date', '# reserv.', 'Client', 'Produit', 'Format', 'Fournisseur', 'Quantite'];
      const rows = this.getIntentsExportRows().map((row) => [
        row.date,
        row.reservationId,
        row.customerName,
        row.productName,
        row.formatLabel,
        row.providerName,
        row.quantity,
      ]);

      let html = '<table border="1"><thead><tr>';
      headers.forEach((header) => {
        html += `<th style="background-color: #4472C4; color: white; font-weight: bold;">${header}</th>`;
      });
      html += '</tr></thead><tbody>';

      rows.forEach((row) => {
        html += '<tr>';
        row.forEach((cell, index) => {
          const style = index === 6 ? 'text-align: right;' : '';
          html += `<td style="${style}">${cell == null ? '' : cell}</td>`;
        });
        html += '</tr>';
      });
      html += '</tbody></table>';

      this.downloadFile(html, filename + '.xls', 'application/vnd.ms-excel');
    },
    downloadIntentsTableHTML(filename) {
      const headers = ['Date', '# reserv.', 'Client', 'Produit', 'Format', 'Fournisseur', 'Quantite'];
      const rows = this.getIntentsExportRows().map((row) => [
        row.date,
        row.reservationId,
        row.customerName,
        row.productName,
        row.formatLabel,
        row.providerName,
        row.quantity,
      ]);

      let html = `<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <title>${filename}</title>
  <style>
    body { font-family: Arial, sans-serif; margin: 20px; }
    h1 { color: #333; }
    table { border-collapse: collapse; width: 100%; margin-top: 20px; }
    thead { background-color: #4472C4; color: white; }
    th, td { border: 1px solid #ddd; padding: 12px; text-align: left; }
    tr:nth-child(even) { background-color: #f9f9f9; }
    tr:hover { background-color: #f0f0f0; }
    td:last-child { text-align: right; }
  </style>
</head>
<body>
  <h1>Intentions d'achat</h1>
  <p>Période: ${moment(this.filters.startDate).format('DD/MM/YYYY')} - ${moment(this.filters.endDate).format('DD/MM/YYYY')}</p>
  <table>
    <thead>
      <tr>`;

      headers.forEach((header) => {
        html += `<th>${header}</th>`;
      });
      html += '</tr></thead><tbody>';

      rows.forEach((row) => {
        html += '<tr>';
        row.forEach((cell, index) => {
          const style = index === 6 ? ' style="text-align: right;"' : '';
          html += `<td${style}>${cell == null ? '' : cell}</td>`;
        });
        html += '</tr>';
      });

      html += `</tbody>
  </table>
</body>
</html>`;

      this.downloadFile(html, filename + '.html', 'text/html');
    },
    downloadFile(content, filename, mimeType) {
      const blob = new Blob([content], { type: mimeType });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    },
    handleFilter(filters){
      localStorage.intents_range=filters.period.code;
      if (filters.period.code === "UNTIL_TODAY") {
        localStorage.intents_startDate = null;
        localStorage.intents_endDate = filters.dateRange[1];
      } else {
        localStorage.intents_startDate = filters.dateRange[0];
        localStorage.intents_endDate = filters.dateRange[1];
      }

      localStorage.intents_customerId = filters.customer!=null ? filters.customer.id : undefined;
      if(filters.customer!=null){
        localStorage.intents_customerName = CustomerUtil.customerName(filters.customer.name,filters.customer.usual_name);
      }
      localStorage.intents_providerId = filters.provider!=null ? filters.provider.id : undefined;
      if(filters.provider!=null){
        localStorage.intents_providerName = CustomerUtil.customerName(filters.provider.name,filters.provider.usual_name);
      }
      localStorage.intents_product = _.get(filters, 'product') != null ? JSON.stringify(_.get(filters, 'product')) : null;
      localStorage.intents_provider = _.get(filters, 'provider') != null ? JSON.stringify(_.get(filters, 'provider')) : null;
      this.setFilters();
      this.fetchData();
    },
    openFilterDialog(){
      this.reportFilterVisible = true;
    },
    closeFilterDialog(){
      this.reportFilterVisible=false;
    },
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
    fetchData(format = null){
      this.loading = true;


      return reservationAPI.fetchReservationsV2(this.getPreparedFilters())
        .then(data=>{
          this.data = data;
          this.productsPagination.page = 1;
          this.producersPagination.page = 1;
          this.loading = false;
          this.initChart();
        }).catch(err=>{
          console.log(err);
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    setFilters(){
      if(localStorage.intents_range==null){
        localStorage.intents_range='UNTIl_TODAY';
      }

      this.customerName = localStorage.intents_customerName;

      this.filters.range=localStorage.intents_range;
      this.filters.customerId=localStorage.intents_customerId!='undefined' && localStorage.intents_customerId!=null  ? parseInt(localStorage.intents_customerId) : undefined;
      this.filters.providerId=localStorage.intents_providerId!='undefined' && localStorage.intents_providerId!=null  ? parseInt(localStorage.intents_providerId) : undefined;


      if(this.filters.range=='FISCAL_YEAR' && this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        localStorage.intents_startDate = this.fiscalYearDate.startDate;
        localStorage.intents_endDate = this.fiscalYearDate.endDate;
      }else if(this.filters.range=='LAST_FISCAL_YEAR' && this.lastFiscalYearDate.startDate!=null && this.lastFiscalYearDate.endDate!=null){
        localStorage.intents_startDate = this.lastFiscalYearDate.startDate;
        localStorage.intents_endDate = this.lastFiscalYearDate.endDate;
      }else if(this.filters.range=='MONTH'){
        localStorage.intents_startDate = this.month.startDate;
        localStorage.intents_endDate = this.month.endDate;
      }else if(this.filters.range=='LAST_MONTH'){
        localStorage.intents_startDate = this.lastMonth.startDate;
        localStorage.intents_endDate = this.lastMonth.endDate;
      }else if(this.filters.range=='UNTIL_TODAY'){
        localStorage.intents_startDate = null;
        localStorage.intents_endDate = moment().format('YYYY-MM-DD');
      } else {
        localStorage.intents_startDate = null;
        localStorage.intents_endDate = moment().format('YYYY-MM-DD');
      }

      this.filters.product = localStorage.intents_product != null ? JSON.parse(localStorage.intents_product) : null;
      this.filters.provider = localStorage.intents_provider != null ? JSON.parse(localStorage.intents_provider) : null;
      this.filters.startDate = localStorage.intents_startDate;
      this.filters.endDate = localStorage.intents_endDate;
    },
  },
  mounted(){
    this.setPageWidth();
    this.$refs.summary.$options._parentVnode.elm.classList.remove('el-table--enable-row-hover')
  },
  created(){
    this.loading = true;
    this.setFilters();
    this.fetchData();
  },
  beforeDestroy(){
    this.data = [];
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}



.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
